import moment from "moment";

export default {
    state: { // state des Moduls wird direkt auf die variable state.modulX gemappt
        searchValues: {
            von: moment(Date.now()).add(-6, 'months').toDate(),
            bis: Date.now(),
            tierartid: 1,
            tierarten: [
                { id: 1, name: { de: 'Kuh', fr: 'Vache', it: 'Mucca' } },
                { id: 2, name: { de: 'Ziege', fr: 'Chèvre', it: 'Capra' } },
                { id: 3, name: { de: 'Schaf', fr: 'Brebis', it: 'Pecora' } },
                { id: 4, name: { de: 'Büffel', fr: 'Bufflonne', it: 'Bufala' } }
            ],
            tierartSelected: 1,
            betriebSelected: null,
            betriebSelectedBtrIDs: [],
        }
    },
    actions: { // call from outside as action: this.$store.dispatch('LOAD_abcd')
        setVon({ commit }, value) {
            commit('setVon', value)
        },
        setBis({  commit }, value) {
            commit('setBis', value)
        },
        async setTierarten({commit},value){
            commit('setTierarten',value)
            commit('setTierartSelected',value[0].id) //die erste im Array als selektierte meistens kuh geht aber auch für Ziegen #929
        },
        setTierartSelected({  commit }, value) {
            commit('setTierartSelected', value)
        },
        async setBetriebSelected({  commit, rootState }, value) {
            commit('setBetriebSelected', value)
            let btrIDs = new Array()
            if (value == 0) { rootState.betriebeStore.betriebe.list.forEach((btrX) => { btrIDs.push(btrX.ID) }) }
            else { btrIDs.push(value) }
            //console.log(btrIDs)
            commit('setBetriebSelectedBtrIDs', btrIDs)
            //state.searchValues.betriebSelectedBtrI
        }
    },
    mutations: { //call with this.$store.commit('setExampleFn',{'a':'b'})
        setVon(state, value) {
            state.searchValues.von = value
        },
        setBis(state, value) {
            state.searchValues.bis = value
        },
        setTierarten(state, value) {
            state.searchValues.tierarten = value
        },
        setTierartSelected(state, value) {
            state.searchValues.tierartSelected = value
        },
        setAnatypSelected(state, value) {
            state.searchValues.anatypSelected = value
        },
        setBetriebSelectedBtrIDs(state, values) {
            state.searchValues.betriebSelectedBtrIDs = values
        },
        setBetriebSelected(state, betriebSelected) {
            state.searchValues.betriebSelected = betriebSelected
        }
    }
}